const pageNameKey = "otaAcceptAndPush";

export const otaAcceptAndPushEn = {
  [pageNameKey]: {
    titleTemplateFirmware:
      "Firmware Installation {itemName} Approved by Operator",
    titleTemplateBackup: "Backup Installation {itemName} Approved by Operator",
    descriptionTemplateFirmware:
      "{approver} accepted the firmware installation. Now, review and push the firmware package to the machine.",
    descriptionTemplateBackup:
      "{approver} accepted the backup installation. Now, review and push the backup package to the machine.",
    acceptAndPushButtonTextFirmware: "Accept and Push Firmware",
    acceptAndPushButtonTextBackup: "Accept and Push Backup",
    cancelRequestButtonText: "Cancel",
    cancelSuccessMessage: "Installation process canceled successfully",
    cancelFailureMessage: "Failed to cancel installation process",
    waitMessage:
      "Wait until the availability check of the machine is finished.",
  },
};

export const otaAcceptAndPushPtBr = {
  [pageNameKey]: {
    titleTemplateFirmware:
      "Instalacao do firmware {itemName} aprovada pelo Operador",
    titleTemplateBackup:
      "Instalacao do backup {itemName} aprovada pelo Operador",
    descriptionTemplateFirmware:
      "{approver} aceitou a instalacao do firmware. Agora, revise e envie o pacote de firmware para a maquina.",
    descriptionTemplateBackup:
      "{approver} aceitou a instalacao do backup. Agora, revise e envie o pacote de backup para a maquina.",
    acceptAndPushButtonTextFirmware: "Aceitar e enviar firmware",
    acceptAndPushButtonTextBackup: "Aceitar e enviar backup",
    cancelRequestButtonText: "Cancelar",
    cancelSuccessMessage: "Processo de instalacao cancelado com sucesso",
    cancelFailureMessage: "Falha ao cancelar o processo de instalacao",
    waitMessage:
      "Aguarde ate que a verificacao de disponibilidade da maquina seja concluida.",
  },
};

export const otaAcceptAndPushDe = {
  [pageNameKey]: {
    titleTemplateFirmware:
      "Firmware-Installation {itemName} vom Operator genehmigt",
    titleTemplateBackup:
      "Backup-Installation {itemName} vom Operator genehmigt",
    descriptionTemplateFirmware:
      "{approver} hat die Firmware-Installation akzeptiert. Pruefen Sie nun das Firmware-Paket und uebertragen Sie es auf die Maschine.",
    descriptionTemplateBackup:
      "{approver} hat die Backup-Installation akzeptiert. Pruefen Sie nun das Backup-Paket und uebertragen Sie es auf die Maschine.",
    acceptAndPushButtonTextFirmware: "Firmware akzeptieren und uebertragen",
    acceptAndPushButtonTextBackup: "Backup akzeptieren und uebertragen",
    cancelRequestButtonText: "Abbrechen",
    cancelSuccessMessage: "Installationsprozess erfolgreich abgebrochen",
    cancelFailureMessage:
      "Installationsprozess konnte nicht abgebrochen werden",
    waitMessage:
      "Warten Sie, bis die Verfuegbarkeitspruefung der Maschine abgeschlossen ist.",
  },
};

export const otaAcceptAndPushZhHans = {
  [pageNameKey]: {
    titleTemplateFirmware: "固件安装 {itemName} 已由操作员批准",
    titleTemplateBackup: "备份安装 {itemName} 已由操作员批准",
    descriptionTemplateFirmware:
      "{approver} 已接受固件安装。现在，请审核并将固件包推送到设备。",
    descriptionTemplateBackup:
      "{approver} 已接受备份安装。现在，请审核并将备份包推送到设备。",
    acceptAndPushButtonTextFirmware: "接受并推送固件",
    acceptAndPushButtonTextBackup: "接受并推送备份",
    cancelRequestButtonText: "取消",
    cancelSuccessMessage: "安装流程已成功取消",
    cancelFailureMessage: "取消安装流程失败",
    waitMessage: "请等待，直到设备可用性检查完成。",
  },
};

export const otaAcceptAndPushIt = {
  [pageNameKey]: {
    titleTemplateFirmware:
      "Installazione firmware {itemName} approvata dall'Operatore",
    titleTemplateBackup:
      "Installazione backup {itemName} approvata dall'Operatore",
    descriptionTemplateFirmware:
      "{approver} ha accettato l'installazione del firmware. Ora, rivedi e invia il pacchetto firmware alla macchina.",
    descriptionTemplateBackup:
      "{approver} ha accettato l'installazione del backup. Ora, rivedi e invia il pacchetto backup alla macchina.",
    acceptAndPushButtonTextFirmware: "Accetta e invia firmware",
    acceptAndPushButtonTextBackup: "Accetta e invia backup",
    cancelRequestButtonText: "Annulla",
    cancelSuccessMessage: "Processo di installazione annullato con successo",
    cancelFailureMessage: "Impossibile annullare il processo di installazione",
    waitMessage:
      "Attendere fino al completamento del controllo di disponibilità della macchina.",
  },
};

export const otaAcceptAndPushEs = {
  [pageNameKey]: {
    titleTemplateFirmware:
      "Instalacion de firmware {itemName} aprobada por el Operador",
    titleTemplateBackup:
      "Instalacion de respaldo {itemName} aprobada por el Operador",
    descriptionTemplateFirmware:
      "{approver} acepto la instalacion del firmware. Ahora, revise y envie el paquete de firmware a la maquina.",
    descriptionTemplateBackup:
      "{approver} acepto la instalacion del respaldo. Ahora, revise y envie el paquete de respaldo a la maquina.",
    acceptAndPushButtonTextFirmware: "Aceptar y enviar firmware",
    acceptAndPushButtonTextBackup: "Aceptar y enviar respaldo",
    cancelRequestButtonText: "Cancelar",
    cancelSuccessMessage: "Proceso de instalacion cancelado con exito",
    cancelFailureMessage: "No se pudo cancelar el proceso de instalacion",
    waitMessage:
      "Espere hasta que se complete la verificacion de disponibilidad de la maquina.",
  },
};

export const otaAcceptAndPushNl = {
  [pageNameKey]: {
    titleTemplateFirmware:
      "Firmware-installatie {itemName} goedgekeurd door Operator",
    titleTemplateBackup:
      "Back-upinstallatie {itemName} goedgekeurd door Operator",
    descriptionTemplateFirmware:
      "{approver} heeft de firmware-installatie geaccepteerd. Controleer nu het firmwarepakket en push het naar de machine.",
    descriptionTemplateBackup:
      "{approver} heeft de back-upinstallatie geaccepteerd. Controleer nu het back-uppakket en push het naar de machine.",
    acceptAndPushButtonTextFirmware: "Firmware accepteren en pushen",
    acceptAndPushButtonTextBackup: "Back-up accepteren en pushen",
    cancelRequestButtonText: "Annuleren",
    cancelSuccessMessage: "Installatieproces is succesvol geannuleerd",
    cancelFailureMessage: "Installatieproces kon niet worden geannuleerd",
    waitMessage:
      "Wacht tot de beschikbaarheidscontrole van de machine is voltooid.",
  },
};

export const otaAcceptAndPushTr = {
  [pageNameKey]: {
    titleTemplateFirmware:
      "Firmware Kurulumu {itemName} Operatör Tarafından Onaylandı",
    titleTemplateBackup:
      "Yedekleme Kurulumu {itemName} Operatör Tarafından Onaylandı",
    descriptionTemplateFirmware:
      "{approver} ürün yazılımı kurulumunu kabul etti. Şimdi ürün yazılımı paketini gözden geçirin ve makineye gönderin.",
    descriptionTemplateBackup:
      "{approver} yedekleme kurulumunu kabul etti. Şimdi yedekleme paketini gözden geçirin ve makineye gönderin.",
    acceptAndPushButtonTextFirmware: "Bellenimi Kabul Et ve Gönder",
    acceptAndPushButtonTextBackup: "Yedeklemeyi Kabul Et ve Gönder",
    cancelRequestButtonText: "İptal etmek",
    cancelSuccessMessage: "Yükleme işlemi başarıyla iptal edildi",
    cancelFailureMessage: "Yükleme işlemi iptal edilemedi",
    waitMessage: "Makinenin kullanılabilirlik kontrolü bitene kadar bekleyin.",
  },
};
